var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "Enterprise w-full px-2 h-full"
  }, [_c('div', {
    staticClass: "overflow-hidden h-full min-h-0 flex flex-col p-2"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.unitId,
      expression: "unitId"
    }],
    staticClass: "flex-1 overflow-auto h-full min-h-0 py-1"
  }, [_c('Form', {
    staticClass: "flex-1 overflow-auto h-full min-h-0",
    attrs: {
      "label-position": "top"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": $t("ut1znh6", "单位logo")
    }
  }, [_c('div', {
    staticClass: "flex flex-col overflow-hidden box-border"
  }, [_c('UploadCutter', {
    attrs: {
      "file": _vm.file
    },
    on: {
      "on-change": _vm.onChangeFile
    }
  }), _c('div', [_vm._v($t("og9de8j", "推荐尺寸360*180,小于5M的图片"))])], 1)]), _c('FormItem', {
    attrs: {
      "label": $t("k1e32", "状态")
    }
  }, [_c('div', {
    staticClass: "validation"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.unit.approved === '0',
      expression: "unit.approved === '0'"
    }]
  }, [_vm._v($t("fsi133", "未认证"))]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.unit.approved === '1',
      expression: "unit.approved === '1'"
    }]
  }, [_vm._v($t("dxb9y3", "审核中"))]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.unit.approved === '2',
      expression: "unit.approved === '2'"
    }]
  }, [_vm._v($t("bzrcwb4", "审核失败"))]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.unit.approved === '3',
      expression: "unit.approved === '3'"
    }]
  }, [_vm._v($t("efw273", "已认证"))]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.unit.approved === '2',
      expression: "unit.approved === '2'"
    }],
    staticClass: "response"
  }, [_vm._v(` ${$t("gmepsk5", "审核回复:")}` + _vm._s(_vm.unit.response) + " ")]), _c('div', [_vm.unit.approved === '0' || _vm.unit.approved === '2' ? _c('Button', {
    staticClass: "button",
    on: {
      "click": function ($event) {
        return _vm.openModal('certification');
      }
    }
  }, [_vm._v($t("v5sml66", "验证企业主体"))]) : _vm._e()], 1)])]), _c('FormItem', {
    attrs: {
      "label": $t("aulgy04", "单位简称")
    }
  }, [_c('span', {
    staticClass: "mr10"
  }, [_vm._v(_vm._s(_vm.unit.name))]), _c('a', {
    on: {
      "click": function ($event) {
        return _vm.openModal('editName');
      }
    }
  }, [_vm._v(_vm._s(`${_vm.unit.name ? $t("e5fv2", "修改") : $t("hs6m2", "新增")}`))])]), _vm.unit.approved === '3' ? _c('FormItem', {
    attrs: {
      "label": $t("jsfmux6", "单位唯一代码")
    }
  }, [_c('span', {
    staticClass: "mr10"
  }, [_vm._v(_vm._s(_vm.unit.code))])]) : _vm._e(), _c('FormItem', {
    attrs: {
      "label": $t("gzxu0l4", "营业执照")
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.unit.blrn || $t("dcupdq4", "暂无执照")))]), _vm.unit.blrnPicture ? _c('div', {
    staticClass: "org_code",
    on: {
      "click": function ($event) {
        return _vm.openModal('showImg');
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.unit.blrnPicture,
      "alt": _vm.unit.blrnPicture
    }
  })]) : _vm._e()]), _c('Divider'), _c('FormItem', {
    attrs: {
      "label": $t("auf3qg4", "单位地址")
    }
  }, [_c('span', {
    staticClass: "mr10"
  }, [_vm._v(_vm._s(_vm.unit.address1))]), _c('a', {
    on: {
      "click": function ($event) {
        return _vm.openModal('addAddress');
      }
    }
  }, [_vm._v(_vm._s(`${_vm.unit.address1 ? $t("e5fv2", "修改") : $t("hs6m2", "新增")}`))])]), _c('FormItem', {
    attrs: {
      "label": $t("gpkj3j4", "联系电话")
    }
  }, [_c('span', {
    staticClass: "mr10"
  }, [_vm._v(_vm._s(_vm.unit.switchboardNumber))]), _c('a', {
    on: {
      "click": function ($event) {
        return _vm.openModal('phone');
      }
    }
  }, [_vm._v(_vm._s(`${_vm.unit.switchboardNumber ? $t("e5fv2", "修改") : $t("hs6m2", "新增")}`))])]), _c('FormItem', {
    attrs: {
      "label": $t("auf7ae4", "单位域名")
    }
  }, [_c('span', {
    staticClass: "mr10"
  }, [_vm._v(_vm._s(_vm.unit.website))]), _c('a', {
    on: {
      "click": function ($event) {
        return _vm.openModal('website');
      }
    }
  }, [_vm._v(_vm._s(`${_vm.unit.website ? $t("e5fv2", "修改") : $t("hs6m2", "新增")}`))])]), _c('Divider'), _c('FormItem', {
    attrs: {
      "label": $t("augxr44", "单位成员")
    }
  }, [_vm._v(" " + _vm._s(_vm.unit.userNumber || 0) + ` ${$t("fju1", "人")} `)]), _c('FormItem', {
    attrs: {
      "label": $t("aup9js4", "单位部门")
    }
  }, [_vm._v(" " + _vm._s(_vm.unit.orgNumber || 0) + ` ${$t("fju1", "人")} `)]), _c('Divider'), _c('FormItem', {
    attrs: {
      "label": $t("aulg5k4", "单位类型")
    }
  }, [_vm._v(" " + _vm._s(_vm.unitType) + " ")])], 1)], 1)]), _c('Certification', {
    attrs: {
      "visible": _vm.certification.visible,
      "unit": _vm.unit,
      "unitId": _vm.unitId
    },
    on: {
      "close": function ($event) {
        _vm.certification.visible = false;
      },
      "update": _vm.getUnitMessage
    }
  }), _c('UpdateUnitName', {
    attrs: {
      "unitId": _vm.unitId,
      "visible": _vm.updateUnitName.visible,
      "item": _vm.unit
    },
    on: {
      "close": function ($event) {
        _vm.updateUnitName.visible = false;
      },
      "update": _vm.getUnitMessage
    }
  }), _c('UpdateUnitAddress', {
    attrs: {
      "visible": _vm.updateUnitAddress.visible,
      "item": _vm.unit,
      "unitId": _vm.unitId
    },
    on: {
      "close": function ($event) {
        _vm.updateUnitAddress.visible = false;
      },
      "update": _vm.getUnitMessage
    }
  }), _c('UpdateUnitPhone', {
    attrs: {
      "visible": _vm.updateUnitPhone.visible,
      "item": _vm.unit,
      "unitId": _vm.unitId
    },
    on: {
      "close": function ($event) {
        _vm.updateUnitPhone.visible = false;
      },
      "update": _vm.getUnitMessage
    }
  }), _c('UpdateUnitWebsite', {
    attrs: {
      "visible": _vm.updateUnitWebsite.visible,
      "item": _vm.unit,
      "unitId": _vm.unitId
    },
    on: {
      "close": function ($event) {
        _vm.updateUnitWebsite.visible = false;
      },
      "update": _vm.getUnitMessage
    }
  }), _c('PreviewImg', {
    attrs: {
      "visible": _vm.preview.visible,
      "url": _vm.unit.blrnPicture
    },
    on: {
      "close": function ($event) {
        _vm.preview.visible = false;
      }
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };